import { TranslationKeys } from '~/common/types';
import { IDiameter, IQuotePricingPolicy } from '~/purchase/types';

export const PRICING_POLICY_STATUS_LABEL_LOOKUP: Record<
  IQuotePricingPolicy['computedStatus'],
  keyof TranslationKeys
> = {
  ACTIVE: 'app.quote.pricing_policy.table.status.active',
  DRAFT: 'app.common.status.draft',
  UPCOMING: 'app.common.status.upcoming',
  EXPIRED: 'app.common.status.expired',
  DISABLED: 'app.common.status.disabled',
};

export const PRICING_POLICY_OPERATOR_LABEL_LOOKUP: Record<
  IDiameter['operator'],
  keyof TranslationKeys
> = {
  between: 'app.pricing_policy.form.diameter_operator.between',
  eq: 'app.pricing_policy.form.diameter_operator.equal',
  gte: 'app.pricing_policy.form.diameter_operator.greater_than_or_equal',
  lte: 'app.pricing_policy.form.diameter_operator.lower_than_or_equal',
};
